<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>招标报名列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th>投标方名称</th>
                <th>联系人名</th>
                <th>联系电话</th>
                <th>联系电子邮箱</th>
                <th>附件数量</th>
                <th>状态</th>
                <th>操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="bidEnroll in bidEnrollList">
                <td>{{bidEnroll.merchantName}}</td>
                <td>{{bidEnroll.contactName}}</td>
                <td>{{bidEnroll.contactTel}}</td>
                <td>{{bidEnroll.contactEmail}}</td>
                <td>{{bidEnroll.accFileCount}}</td>
                <td>
                    <span v-if="bidEnroll.resultFlag==0">初始</span>
                    <span v-if="bidEnroll.resultFlag==1">通过</span>
                    <span v-if="bidEnroll.resultFlag==-1">未通过</span>
                <td>
                    <div>
                        <a class="swb-btn-link" v-if="checkState==3" @click="toBidEnrollInfo(bidEnroll.id)">查看详细信息</a>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'
    //
    import tendBidApi from '../../api/tendBid'

    import SwbBidEnrollInfo from './BidEnrollInfo';
    Routes.add(SwbBidEnrollInfo);

    import SwbCallBidDocList from './CallBidDocList';
    Routes.add(SwbCallBidDocList);

    export default{
        name: 'swb-bid-enroll-list',
        path: '/tend/bid/enroll/list',
        pathOld: '/bid/enroll/list',
        avlActions: '',
        avlScopes: 'retailer',
        parentBreadcrumbUrl: '/call/bid/doc/list',
        customBreadcrumb: false,
        notAsResc: true,
        authen: false,
        desc: '报名书列表',
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                checkState: null,
                //
                bidEnrollList: []
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.checkState = this.$route.query.checkState;
            this.getBidEnrollList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBidEnrollList();
            },
            getBidEnrollList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.callDocId = this.$route.query.docId;
                filterItems.applyFlag = true; // applyFlag不为空，查询applyState不为0的数据
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                tendBidApi.getBidEnrollList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        self.bidEnrollList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toBidEnrollInfo: function (bidEnrollId) {
                this.$router.push({
                    path: SwbBidEnrollInfo.path,
                    query: {
                        bidEnrollId: bidEnrollId
                    }
                });
            },
            goBack: function () {
                let self = this;
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbCallBidDocList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/BidEnrollList.vue